(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["contact-form-horeca"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    var params = new URLSearchParams(window.location.search);
    var postedOk = params.get('contact_posted') === 'true';
    var successMsg = document.querySelector('.contact-form__success');
    var errorMsg = document.querySelector('.contact-form__error');

    // Fallback: se Shopify conferma l'invio via URL ma Liquid non l'ha rilevato,
    // mostra il messaggio e nasconde i campi
    if (postedOk && !errorMsg && successMsg && successMsg.hidden) {
      successMsg.hidden = false;
      var fields = successMsg.parentElement.querySelector('.contact-form__fields');
      if (fields) fields.hidden = true;
    }

    // Scroll + focus sul messaggio visibile (successo o errore)
    var msgElement = (successMsg && !successMsg.hidden) ? successMsg : errorMsg;
    if (msgElement) {
      setTimeout(function () {
        msgElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
        msgElement.focus({ preventScroll: true });
      }, 100);
    }

    // Dopo un invio riuscito ripulisce l'URL, così un refresh mostra di nuovo il form vuoto
    if (postedOk) {
      var cleanParams = new URLSearchParams(window.location.search);
      cleanParams.delete('contact_posted');
      var query = cleanParams.toString();
      history.replaceState(null, '', window.location.pathname + (query ? '?' + query : ''));
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["contact-form"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    var params = new URLSearchParams(window.location.search);
    var postedOk = params.get('contact_posted') === 'true';
    var successMsg = document.querySelector('.contact-form__success');
    var errorMsg = document.querySelector('.contact-form__error');

    // Fallback: se Shopify conferma l'invio via URL ma Liquid non l'ha rilevato,
    // mostra il messaggio e nasconde i campi
    if (postedOk && !errorMsg && successMsg && successMsg.hidden) {
      successMsg.hidden = false;
      var fields = successMsg.parentElement.querySelector('.contact-form__fields');
      if (fields) fields.hidden = true;
    }

    // Scroll + focus sul messaggio visibile (successo o errore)
    var msgElement = (successMsg && !successMsg.hidden) ? successMsg : errorMsg;
    if (msgElement) {
      setTimeout(function () {
        msgElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
        msgElement.focus({ preventScroll: true });
      }, 100);
    }

    // Dopo un invio riuscito ripulisce l'URL, così un refresh mostra di nuovo il form vuoto
    if (postedOk) {
      var cleanParams = new URLSearchParams(window.location.search);
      cleanParams.delete('contact_posted');
      var query = cleanParams.toString();
      history.replaceState(null, '', window.location.pathname + (query ? '?' + query : ''));
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["request-form"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    var params = new URLSearchParams(window.location.search);
    var postedOk = params.get('contact_posted') === 'true';
    var successMsg = document.querySelector('.contact-form__success');
    var errorMsg = document.querySelector('.contact-form__error');

    // Fallback: se Shopify conferma l'invio via URL ma Liquid non l'ha rilevato,
    // mostra il messaggio e nasconde i campi
    if (postedOk && !errorMsg && successMsg && successMsg.hidden) {
      successMsg.hidden = false;
      var fields = successMsg.parentElement.querySelector('.contact-form__fields');
      if (fields) fields.hidden = true;
    }

    // Scroll + focus sul messaggio visibile (successo o errore)
    var msgElement = (successMsg && !successMsg.hidden) ? successMsg : errorMsg;
    if (msgElement) {
      setTimeout(function () {
        msgElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
        msgElement.focus({ preventScroll: true });
      }, 100);
    }

    // Dopo un invio riuscito ripulisce l'URL, così un refresh mostra di nuovo il form vuoto
    if (postedOk) {
      var cleanParams = new URLSearchParams(window.location.search);
      cleanParams.delete('contact_posted');
      var query = cleanParams.toString();
      history.replaceState(null, '', window.location.pathname + (query ? '?' + query : ''));
    }

    // Validazione domeniche + filtro orari in base al giorno
    document.querySelectorAll('input[data-no-sundays]').forEach(function (input) {
      var form = input.closest('form');
      var eventTimeSelect = form ? form.querySelector('select[name="contact[Orario evento]"]') : null;

      function updateEventTimeOptions() {
        if (!eventTimeSelect) return;

        var options = eventTimeSelect.querySelectorAll('option[data-event-time-day]');
        var placeholderOption = eventTimeSelect.querySelector('option[value=""]');
        var dayType = null;

        if (input.value) {
          var parts = input.value.split('-').map(Number);
          var date = new Date(parts[0], parts[1] - 1, parts[2]);
          var day = date.getDay(); // 0 = domenica, 6 = sabato
          if (day === 6) {
            dayType = 'weekend';
          } else if (day !== 0) {
            dayType = 'weekday';
          }
        }

        if (placeholderOption) {
          if (!placeholderOption.hasAttribute('data-default-text')) {
            placeholderOption.setAttribute('data-default-text', placeholderOption.textContent);
          }
          placeholderOption.textContent = dayType
            ? placeholderOption.getAttribute('data-default-text')
            : 'Seleziona prima la data';
        }

        options.forEach(function (option) {
          var allowedDays = option.getAttribute('data-event-time-day').split(' ');
          var shouldShow = dayType && allowedDays.indexOf(dayType) !== -1;
          option.hidden = !shouldShow;
          option.disabled = !shouldShow;
        });

        var selectedOption = eventTimeSelect.options[eventTimeSelect.selectedIndex];
        if (selectedOption && selectedOption.hidden) {
          eventTimeSelect.value = '';
        }
      }

      input.addEventListener('change', function () {
        if (!this.value) {
          updateEventTimeOptions();
          return;
        }
        var parts = this.value.split('-').map(Number);
        var date = new Date(parts[0], parts[1] - 1, parts[2]);
        if (date.getDay() === 0) {
          this.setCustomValidity('La domenica non è disponibile. Seleziona un giorno da lunedì a sabato.');
          this.reportValidity();
          this.value = '';
          this.setCustomValidity('');
        }
        updateEventTimeOptions();
      });

      // Inizializza al caricamento (es. valore precompilato)
      updateEventTimeOptions();
    });

    // Condizionamento dei campi "tour details"
    var eventTypeSelect = document.querySelector('select[name="contact[Tipologia di evento]"]');
    if (eventTypeSelect) {
      var conditionalElements = document.querySelectorAll('[data-conditional-fields="tour-details"]');

      function updateConditionalFields() {
        var selectedValue = eventTypeSelect.value;
        var shouldShow = selectedValue === 'Super Tour' || selectedValue === 'Top Tour';

        conditionalElements.forEach(function (element) {
          if (shouldShow) {
            element.style.display = '';
            element.querySelectorAll('input, select').forEach(function (field) {
              field.setAttribute('required', 'required');
            });
          } else {
            element.style.display = 'none';
            element.querySelectorAll('input, select').forEach(function (field) {
              field.removeAttribute('required');
            });
          }
        });
      }

      // Inizializza al caricamento
      updateConditionalFields();

      // Aggiorna al cambio della selezione
      eventTypeSelect.addEventListener('change', updateConditionalFields);
    }
  });
  } catch(e) { console.error(e); }
})();

})();
